import React, { useEffect, useRef } from 'react';
import SqftUseCanvas from './SqftUseCanvas';
import sqftEventManager from "../store/sqftEventManager";
import SqftStore from "../store/sqftStore";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import useElementSize from '../../../hocs/useElementSize';
import {CANVAS_FIT_MODE} from "../store/canvasHelper";

const SqftCanvas = (props) => {
  const {
    options = {},
    visualizersLoadedLength,
    fabricatorData,
    sqftVisited,
    intl,
    quotes,
    activeQuoteIndex,
    fitMode = CANVAS_FIT_MODE.CONTAINER,
    minHeight = 300,
    ...rest
  } = props;

  const wrapperRef = useRef(null);
  const wrapperSize = useElementSize(wrapperRef);

  const getTargetSize = () => ({
    width: Math.max(1, Math.floor(wrapperSize.width)),
    height: Math.max(minHeight, Math.floor(wrapperSize.height)),
  });

  const { context } = options;
  const canvasRef = SqftUseCanvas(
    sqftEventManager.renderEvents,
    { context },
    visualizersLoadedLength,
    fabricatorData,
    sqftVisited,
    intl,
    quotes,
    activeQuoteIndex,
    getTargetSize
  );

  useEffect(() => {
    if (!canvasRef.current) return;
    SqftStore.canvas.width = canvasRef.current.clientWidth;
    SqftStore.canvas.height = canvasRef.current.clientHeight;
  }, [canvasRef, wrapperSize.width, wrapperSize.height, fitMode]);

  useEffect(() => {
    return () => {
      sqftEventManager.canvas.isWithEventManager = false;
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      style={{ width: '100%', height: '100%', minHeight }}
    >
      <canvas
        id='workspace'
        className='workspace-canvas'
        ref={canvasRef}
        {...rest}
      />
    </div>
  );
};

const mapStateToProps = (store) => ({
  visualizersLoadedLength: store.serverState.visualizersLoaded,
  fabricatorData: store.fabricatorState,
  sqftVisited: store.sqftState.sqftFeaturesPopup.visited,
  quotes: store.quotesState.quotes,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
});

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftCanvas)
);
